import { ToggleNumbers } from "components/design/ToggleNumbers";
import { NumericInput } from "components/NumericInput/NumericInput";
import { PriceInput } from "components/PriceInput/PriceInput";
import { useTypedFormikContext } from "hooks/useTypedFormikContext";
import { ReactNode } from "react";

type InvoiceDiscountFieldsProps = {
  hasItemLevelTax?: boolean;
};

type DiscountValues = {
  discount: string;
  discount_type: string;
  tax: string;
  tax_type: string;
  currency?: string;
};

const PERCENT = "PERCENT";

const AmountOrPercentInput = ({
  name,
  label,
  isPercent,
  currencyCode,
  toggle,
}: {
  name: string;
  label: string;
  isPercent: boolean;
  currencyCode?: string;
  toggle: ReactNode;
}) => {
  if (isPercent) {
    return (
      <NumericInput
        label={label}
        storeNumeric
        fieldProps={{ name }}
        numericProps={{
          customSize: "regular",
          fixedDecimalScale: true,
          decimalScale: 2,
          suffix: " %",
          allowNegative: false,
          rightComponent: toggle,
        }}
      />
    );
  }

  return (
    <PriceInput
      name={name}
      label={label}
      customSize="regular"
      allowNegative={false}
      currencyCode={currencyCode}
      rightComponent={toggle}
    />
  );
};

export const InvoiceDiscountFields = ({
  hasItemLevelTax,
}: InvoiceDiscountFieldsProps) => {
  const { values, setFieldValue } = useTypedFormikContext<DiscountValues>();

  const handleDiscountTypeChange = (value: string) =>
    setFieldValue("discount_type", value);
  const handleTaxTypeChange = (value: string) =>
    setFieldValue("tax_type", value);

  return (
    <div className="t-flex t-flex-col t-gap-4">
      <AmountOrPercentInput
        name="discount"
        label="Enter discount value/percentage (if any)"
        isPercent={values.discount_type === PERCENT}
        currencyCode={values.currency}
        toggle={
          <ToggleNumbers
            value={values.discount_type}
            onValueChange={handleDiscountTypeChange}
          />
        }
      />
      {!hasItemLevelTax && (
        <div className="t-grid t-grid-cols-2 t-gap-3 sm:t-grid-cols-1">
          <AmountOrPercentInput
            name="tax"
            label="Tax"
            isPercent={values.tax_type === PERCENT}
            currencyCode={values.currency}
            toggle={
              <ToggleNumbers
                value={values.tax_type}
                onValueChange={handleTaxTypeChange}
              />
            }
          />
          <PriceInput
            allowNegative={false}
            name="paid_amount"
            customSize="regular"
            label="Advance paid"
            currencyCode={values.currency}
            showCurrencyFlag
          />
        </div>
      )}
    </div>
  );
};
